// greetingFor is the greeting Today shows when the model wrote none. It uses
// the same boundaries as the server's PartOfDay (morning from 05:00, afternoon
// from 12:00, evening from 17:00) and the business's timezone, so it never
// contradicts what the model was told.
export function greetingFor(now: Date = new Date(), timeZone?: string): string {
  const hour = Number(
    new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hourCycle: 'h23', timeZone }).format(now),
  )
  if (hour >= 5 && hour < 12) return 'Good morning'
  if (hour >= 12 && hour < 17) return 'Good afternoon'
  if (hour >= 17) return 'Good evening'
  // Overnight, a neutral hello, as the server's Greeting (review 2026-10-14).
  return 'Hello'
}
